const f_O5zAEbylVEdnF53mAmkBE3s7hKZpLJNccIpVfycsVjU = ({
    name: 'Test',
    label: 'test',
});

const b_ZD8xe0tDDHb6WP9zG09nDC_r4pdum22GLDmvdfRSc8Y = ({
    bundle: 'quote',
    editor: {
        previewWidth: 600,
        editTitle: (el) => el.querySelector('figcaption')?.textContent,
        addBehaviour: 'no-form',
    },
    options: {
        alignment: {
            type: 'radios',
            label: 'Alignment',
            default: 'left',
            displayAs: 'icons',
            options: {
                left: { label: 'left', icon: 'icon-blokkli-option-left' },
                right: { label: 'right', icon: 'icon-blokkli-option-right' },
            },
        },
    },
});

const b_z_PD1d7ayF6D7T7L6jozzRtRjSnUKNgO68hY8spvjkY = ({
    bundle: "from_library"
});

const b_YTo_Bh_BHKb8cDCaTnlwUrxSl_UN1TSqX71yK4_5ENk = ({
    bundle: "blokkli_fragment",
    editor: {
        disableEdit: true
    }
});

const b_xnlIk4Vz0LPjxyXHLu4BcqJSupR_kxyxi8YBrepvpLY = ({
    bundle: 'iframe',
    globalOptions: ['spacing'],
    options: {
        inContainer: {
            type: 'checkbox',
            label: 'Container',
            default: true,
        },
    },
});

const b_wuZd2Bizx7KVvvPQLlHnVNwFwxQfr_HG4LFa_mMU0jE = ({
    bundle: 'call_to_action_section',
    options: {
        size: {
            type: 'radios',
            label: 'Grösse',
            default: 'medium',
            displayAs: 'icons',
            options: {
                medium: {
                    label: 'Mittel',
                    icon: 'icon-blokkli-option-medium',
                },
                large: {
                    label: 'Gross',
                    icon: 'icon-blokkli-option-large',
                },
            },
        },
        imageAlignment: {
            type: 'radios',
            label: 'Image alignment',
            default: 'left',
            displayAs: 'icons',
            options: {
                left: {
                    label: 'Bild links',
                    icon: 'icon-blokkli-option-image-left',
                },
                right: {
                    label: 'Bild rechts',
                    icon: 'icon-blokkli-option-image-right',
                },
            },
        },
        infoBoxAlignment: {
            type: 'radios',
            label: 'Info box alignment',
            default: 'top',
            displayAs: 'icons',
            options: {
                top: {
                    label: 'Ausrichtung oben',
                    icon: 'icon-blokkli-option-box-top',
                },
                bottom: {
                    label: 'Ausrichtung unten',
                    icon: 'icon-blokkli-option-box-bottom',
                },
            },
        },
        backgroundColor: {
            type: 'radios',
            label: 'Hintergrundfarbe',
            default: 'lightGray',
            displayAs: 'colors',
            options: {
                lightGray: {
                    label: 'Hellgrau',
                    hex: '#DCDCDE',
                },
                mediumGray: {
                    label: 'Grau',
                    hex: '#949BA9',
                },
            },
        },
    },
});

const b_Wc5mWqaUxhHkRYB7MNT7ffxLlJdXBBdbVrVaOjLXri8 = ({
    bundle: 'chart',
    globalOptions: ['spacing'],
    options: {
        chartType: {
            type: 'radios',
            label: 'Diagrammtyp',
            default: 'barHorizontal',
            displayAs: 'icons',
            options: {
                barHorizontal: {
                    label: 'Balken Horizontal',
                    icon: 'icon-blokkli-option-chart-bar-horizontal',
                },
                bar: {
                    label: 'Balken',
                    icon: 'icon-blokkli-option-chart-bar',
                },
                line: { label: 'Linie', icon: 'icon-blokkli-option-chart-line' },
            },
        },
        decimalPoints: {
            type: 'number',
            label: 'Kommastellen',
            default: 1,
            min: 0,
            max: 5,
        },
        linePaddingBottom: {
            type: 'range',
            label: 'Padding (unten)',
            default: 0,
            min: 0,
            max: 1,
            step: 0.01,
        },
        linePaddingTop: {
            type: 'range',
            label: 'Padding (oben)',
            default: 0,
            min: 0,
            max: 1,
            step: 0.01,
        },
        linePaddingLeft: {
            type: 'range',
            label: 'Padding (links)',
            default: 0,
            min: 0,
            max: 200,
            step: 1,
        },
        rotationOffset: {
            type: 'range',
            label: 'Rotation',
            default: 0,
            min: 0,
            max: 1,
            step: 0.01,
        },
        colorPalette: {
            type: 'radios',
            label: 'Farbpalette',
            default: 'sand',
            displayAs: 'colors',
            options: {
                sand: { label: 'Sand', class: 'bg-sand' },
                violett: { label: 'Violett', class: 'bg-violett' },
            },
        },
        barDistribution: {
            type: 'radios',
            label: 'Verteilung',
            default: 'largest',
            options: {
                percentage: 'Prozentual',
                largest: 'Grösster Wert',
            },
        },
        valuesOnHover: {
            type: 'checkbox',
            label: 'Werte on Hover',
            default: false,
        },
        isStacked: {
            type: 'checkbox',
            label: 'Stacked',
            default: false,
        },
        isTrendline: {
            type: 'checkbox',
            label: 'Trendline',
            default: false,
        },
        isHidden: {
            type: 'checkbox',
            label: 'Verstecken',
            default: false,
        },
        format: {
            type: 'radios',
            label: 'Format',
            default: 'large',
            displayAs: 'icons',
            options: {
                small: { label: 'small', icon: 'icon-blokkli-option-small' },
                large: { label: 'large', icon: 'icon-blokkli-option-large' },
            },
        },
    },
    editor: {
        determineVisibleOptions: (ctx) => {
            if (ctx.options.chartType === 'bar') {
                return [
                    'isHidden',
                    'spacing',
                    'chartType',
                    'colorPalette',
                    'valuesOnHover',
                    'decimalPoints',
                    'isStacked',
                    'isTrendline',
                    'format',
                ];
            }
            else if (ctx.options.chartType === 'barHorizontal') {
                return [
                    'isHidden',
                    'spacing',
                    'chartType',
                    'barDistribution',
                    'colorPalette',
                    'valuesOnHover',
                    'decimalPoints',
                    'format',
                ];
            }
            else if (ctx.options.chartType === 'line') {
                return [
                    'isHidden',
                    'spacing',
                    'chartType',
                    'colorPalette',
                    'linePaddingTop',
                    'linePaddingBottom',
                    'linePaddingLeft',
                    'decimalPoints',
                    'format',
                ];
            }
            return ['isHidden', 'chartType'];
        },
    },
});

const b_W69iu88z8RJtGf7iQwLzzEk_jf_97USLPm9ncbU_wFM = ({
    bundle: 'teaser_list',
    options: {
        teaserStyle: {
            type: 'radios',
            label: 'Darstellung',
            default: 'grid',
            displayAs: 'icons',
            options: {
                grid: { label: 'grid', icon: 'icon-blokkli-option-grid' },
                staggered: {
                    label: 'Versetzt',
                    icon: 'icon-blokkli-option-staggered',
                },
                sliderDesktop: {
                    label: 'Slider desktop',
                    icon: 'icon-blokkli-option-slider-desktop',
                },
            },
        },
        sliderStyle: {
            type: 'radios',
            label: 'Slider Darstellung',
            default: 'stack',
            displayAs: 'icons',
            options: {
                stack: { label: 'Stapel', icon: 'icon-blokkli-option-stapel' },
                sliderMobile: {
                    label: 'Slider mobile',
                    icon: 'icon-blokkli-option-slider',
                },
            },
        },
    },
    editor: {
        editTitle: (el) => el.querySelector('h2')?.innerText,
        addBehaviour: 'no-form',
    },
});

const b_SvCmFLfsxQALCqTF3o_q_u2_J_dOKzq_kdSRBF2zRmk = ({
    bundle: 'media_list',
    globalOptions: ['spacing'],
    editor: {
        editTitle: (el) => el.querySelector('h2')?.textContent,
    },
});

const b_Rnax2e3Lz5SEMemyKl3YlSKNZVEBzCoCHhxEh_X5764 = ({
    bundle: 'accordeon',
    editor: {
        editTitle: (el) => el.querySelector('h2')?.textContent,
        addBehaviour: 'no-form',
    },
});

const b_QQsVczLd3YGdv8OlIO_pPL0k5gYu0eEqU2O0DAtu5QY = ({
    bundle: 'view',
    chunkName: 'rare',
});

const b_P821jc2gyKFMwettWqJAOD2hmnwVVCiR4ojjywl72k4 = ({
    bundle: 'infobox',
    globalOptions: ['spacing'],
    options: {
        colorPalette: {
            type: 'radios',
            label: 'Farbpalette',
            default: 'sand',
            displayAs: 'colors',
            options: {
                sand: { label: 'Sand', class: 'bg-sand' },
                violett: { label: 'Violett', class: 'bg-violett' },
            },
        },
        format: {
            type: 'radios',
            label: 'Bildformat',
            default: 'large',
            displayAs: 'icons',
            options: {
                big: { label: 'large', icon: 'icon-blokkli-option-large' },
                text: { label: 'medium', icon: 'icon-blokkli-option-medium' },
            },
        },
    },
});

const b_oH6HD_FV_SvlTq9s5ELHomJh_LtNLfg_F9Qk5FTfwUg = ({
    bundle: 'milestones',
    globalOptions: ['spacing'],
    options: {
        colorPalette: {
            type: 'radios',
            label: 'Farbpalette',
            default: 'sand',
            displayAs: 'colors',
            options: {
                sand: { label: 'Sand', class: 'bg-sand' },
                violett: { label: 'Violett', class: 'bg-violett' },
            },
        },
        format: {
            type: 'radios',
            label: 'Bildformat',
            default: 'large',
            displayAs: 'icons',
            options: {
                big: { label: 'large', icon: 'icon-blokkli-option-large' },
                text: { label: 'medium', icon: 'icon-blokkli-option-medium' },
            },
        },
    },
});

const b_O6UlFcc3wchuJgPEPOu_dh_UHgzVN94ftwTjQnP1LTM = ({
    bundle: 'webform',
    chunkName: 'rare',
});

const b_NqYDVS6361AcEiJv9sojhqcvqaXzaOHZg82tP3Rg88Q = ({
    bundle: 'video',
    editor: {
        editTitle: (el) => el.querySelector('h2')?.innerText,
    },
    globalOptions: ['spacing'],
    options: {
        format: {
            type: 'radios',
            label: 'Bildformat',
            default: 'full',
            displayAs: 'icons',
            options: {
                full: { label: 'extra large', icon: 'icon-blokkli-option-xlarge' },
                big: { label: 'large', icon: 'icon-blokkli-option-large' },
                text: { label: 'medium', icon: 'icon-blokkli-option-medium' },
                small: { label: 'small', icon: 'icon-blokkli-option-small' },
            },
        },
    },
});

const b_mqfNSqNjwDd0KU7KW523B4th6heWu7yjnK1YB2JXZCk = ({
    bundle: 'teaser_with_external_link',
    editor: {
        editTitle: (el) => el.querySelector('h3')?.innerText,
        mockProps: (text) => {
            return {
                overrideTitle: text || 'Teaser Titel',
                link: {
                    uri: {
                        path: '/',
                    },
                },
            };
        },
    },
});

const b_Kd9AyEBEpo955eXBFPj2whyMTEAFG2WSICi31lPcfxI = ({
    bundle: 'table',
    globalOptions: ['spacing'],
    options: {
        equalizeWidths: {
            type: 'checkbox',
            label: 'Alle Spalten gleich breit',
            default: true,
        },
        mobileTableStyle: {
            type: 'radios',
            label: 'Mobile Darstellung',
            default: 'horizontal',
            displayAs: 'icons',
            options: {
                vertical: {
                    label: 'Vertikal',
                    icon: 'icon-blokkli-option-table-vertical',
                },
                horizontal: {
                    label: 'Horizontal',
                    icon: 'icon-blokkli-option-table-horizontal',
                },
            },
        },
        sticky: {
            type: 'radios',
            label: 'Sticky',
            default: 'none',
            options: {
                none: '-',
                top: 'Oben',
            },
        },
    },
    editor: {
        editTitle: (el) => el.querySelector('figcaption')?.innerText,
        determineVisibleOptions: (ctx) => {
            if (ctx.options.mobileTableStyle === 'vertical') {
                return ['equalizeWidths', 'mobileTableStyle', 'spacing'];
            }
            return ['equalizeWidths', 'mobileTableStyle', 'sticky', 'spacing'];
        },
    },
});

const b_fxcUnyIjUiIWx1rgtX0dLiNM22aEC33fVRHHLdqiWXE = ({
    bundle: 'text_image',
});

const b_eh8tCsK7wnmnQy5zHUBJxx_anqZvWJqfOx4Y5p_WPyM = ({
    bundle: 'text',
    editor: {
        addBehaviour: 'no-form',
        editTitle: (el) => el.textContent,
        getDraggableElement: (el) => el.querySelector('.ck-content'),
        determineVisibleOptions: (ctx) => {
            if (!ctx.parentType) {
                return ['spacing'];
            }
            return [];
        },
    },
    globalOptions: ['spacing'],
});

const b_dVepD0eEmz5J4mtx6JA0_B2g_k9aK_9Di9ctXO0O5AI = ({
    bundle: 'divider',
    globalOptions: ['spacing'],
});

const b_ch06ugUeskqgpetl2fP0tti_H8DvzqAXNBWGRc5aj_U = ({
    bundle: 'icon_text_list',
    editor: {
        editTitle: (el) => el.querySelector('h2')?.textContent,
        getDraggableElement: (el) => el.querySelector('.paragraph-icon-text-list'),
    },
    globalOptions: ['spacing'],
});

const b_cDj4TWfjFUrwMFcI_1KHarrXDMTqdsYf0rg5O_AUVVw = ({
    bundle: 'teaser',
    editor: {
        editTitle: (el) => el.querySelector('h3')?.innerText,
        mockProps: (text) => {
            return {
                overrideTitle: text || 'Teaser Titel',
                link: {
                    uri: {
                        path: '/',
                    },
                },
            };
        },
    },
});

const b_cd9Ebu63o1G15OzG76eG4YvqpwRPO4q5ouePtFn_NoM = ({
    bundle: 'contact_box',
    globalOptions: ['spacing'],
    options: {
        backgroundColor: {
            type: 'radios',
            label: 'Hintergrundfarbe',
            default: 'light',
            displayAs: 'colors',
            options: {
                light: {
                    label: 'Hell',
                    hex: '#FFFFFF',
                },
                red: {
                    label: 'Rot',
                    hex: '#E9423F',
                },
            },
        },
    },
});

const b_BwK9rV92vfuPZdhNtUxjMOlPQ1sq0Wlx5d5DPsXUalY = ({
    bundle: 'button',
    editor: {
        editTitle: (el) => el.textContent,
    },
    options: {
        buttonType: {
            type: 'radios',
            label: 'Button type',
            default: 'standard',
            options: {
                standard: 'Standard',
                filled: 'Ausgefüllt',
                textOnly: 'Nur Text',
            },
        },
    },
});

const b_aU_JDJgSZxGLrK_DQ0JqUwSqB88l8tyBHY6PD9J2cog = ({
    bundle: 'carousel',
    editor: {
        editTitle: (el) => el.querySelector('h2')?.textContent,
    },
});

const b_0H_fxwHQZ3_OLvgq9Xjf6__Ku7nIik2JKRZHH9cFPyk = ({
    bundle: 'image',
    globalOptions: ['spacing'],
    options: {
        format: {
            type: 'radios',
            label: 'Bildformat',
            default: 'full',
            displayAs: 'icons',
            options: {
                full: { label: 'extra large', icon: 'icon-blokkli-option-xlarge' },
                big: { label: 'large', icon: 'icon-blokkli-option-large' },
                text: { label: 'medium', icon: 'icon-blokkli-option-medium' },
                small: { label: 'small', icon: 'icon-blokkli-option-small' },
                original: { label: 'original', icon: 'icon-blokkli-option-original' },
            },
        },
        formatAccordeon: {
            type: 'radios',
            label: 'Bildformat',
            default: 'text',
            displayAs: 'icons',
            options: {
                text: { label: 'medium', icon: 'icon-blokkli-option-medium' },
                small: { label: 'small', icon: 'icon-blokkli-option-small' },
            },
        },
    },
    editor: {
        editTitle: (el) => {
            const img = el.querySelector('img');
            return img?.alt || img?.title;
        },
        getDraggableElement: (el) => el.querySelector('figure'),
        determineVisibleOptions: (ctx) => {
            if (!ctx.parentType) {
                return ['format', 'spacing'];
            }
            return ['formatAccordeon'];
        },
    },
});

const b__P4WtvCijR54FDCekoZjWYZDU8_uCeA8JQsvFXqxJZ8 = ({
    bundle: 'icon_text_item',
});

const blocks = [
  b_ZD8xe0tDDHb6WP9zG09nDC_r4pdum22GLDmvdfRSc8Y,
  b_z_PD1d7ayF6D7T7L6jozzRtRjSnUKNgO68hY8spvjkY,
  b_YTo_Bh_BHKb8cDCaTnlwUrxSl_UN1TSqX71yK4_5ENk,
  b_xnlIk4Vz0LPjxyXHLu4BcqJSupR_kxyxi8YBrepvpLY,
  b_wuZd2Bizx7KVvvPQLlHnVNwFwxQfr_HG4LFa_mMU0jE,
  b_Wc5mWqaUxhHkRYB7MNT7ffxLlJdXBBdbVrVaOjLXri8,
  b_W69iu88z8RJtGf7iQwLzzEk_jf_97USLPm9ncbU_wFM,
  b_SvCmFLfsxQALCqTF3o_q_u2_J_dOKzq_kdSRBF2zRmk,
  b_Rnax2e3Lz5SEMemyKl3YlSKNZVEBzCoCHhxEh_X5764,
  b_QQsVczLd3YGdv8OlIO_pPL0k5gYu0eEqU2O0DAtu5QY,
  b_P821jc2gyKFMwettWqJAOD2hmnwVVCiR4ojjywl72k4,
  b_oH6HD_FV_SvlTq9s5ELHomJh_LtNLfg_F9Qk5FTfwUg,
  b_O6UlFcc3wchuJgPEPOu_dh_UHgzVN94ftwTjQnP1LTM,
  b_NqYDVS6361AcEiJv9sojhqcvqaXzaOHZg82tP3Rg88Q,
  b_mqfNSqNjwDd0KU7KW523B4th6heWu7yjnK1YB2JXZCk,
  b_Kd9AyEBEpo955eXBFPj2whyMTEAFG2WSICi31lPcfxI,
  b_fxcUnyIjUiIWx1rgtX0dLiNM22aEC33fVRHHLdqiWXE,
  b_eh8tCsK7wnmnQy5zHUBJxx_anqZvWJqfOx4Y5p_WPyM,
  b_dVepD0eEmz5J4mtx6JA0_B2g_k9aK_9Di9ctXO0O5AI,
  b_ch06ugUeskqgpetl2fP0tti_H8DvzqAXNBWGRc5aj_U,
  b_cDj4TWfjFUrwMFcI_1KHarrXDMTqdsYf0rg5O_AUVVw,
  b_cd9Ebu63o1G15OzG76eG4YvqpwRPO4q5ouePtFn_NoM,
  b_BwK9rV92vfuPZdhNtUxjMOlPQ1sq0Wlx5d5DPsXUalY,
  b_aU_JDJgSZxGLrK_DQ0JqUwSqB88l8tyBHY6PD9J2cog,
  b_0H_fxwHQZ3_OLvgq9Xjf6__Ku7nIik2JKRZHH9cFPyk,
  b__P4WtvCijR54FDCekoZjWYZDU8_uCeA8JQsvFXqxJZ8
]

const fragments = [
  f_O5zAEbylVEdnF53mAmkBE3s7hKZpLJNccIpVfycsVjU
]


const icons = {
  'accordeon': "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><path d=\"M7.41 8.58 12 13.17l4.59-4.59L18 10l-6 6-6-6 1.41-1.42Z\"/></svg>\n",
  'blokkli_fragment': "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><title>newspaper</title><path d=\"M20,11H4V8H20M20,15H13V13H20M20,19H13V17H20M11,19H4V13H11M20.33,4.67L18.67,3L17,4.67L15.33,3L13.67,4.67L12,3L10.33,4.67L8.67,3L7,4.67L5.33,3L3.67,4.67L2,3V19A2,2 0 0,0 4,21H20A2,2 0 0,0 22,19V3L20.33,4.67Z\" /></svg>\n",
  'button': "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><title>button-cursor</title><path d=\"M18.1 15.3C18 15.4 17.8 15.5 17.7 15.6L15.3 16L17 19.6C17.2 20 17 20.4 16.6 20.6L13.8 21.9C13.7 22 13.6 22 13.5 22C13.2 22 12.9 21.8 12.8 21.6L11.2 18L9.3 19.5C9.2 19.6 9 19.7 8.8 19.7C8.4 19.7 8 19.4 8 18.9V7.5C8 7 8.3 6.7 8.8 6.7C9 6.7 9.2 6.8 9.3 6.9L18 14.3C18.3 14.5 18.4 15 18.1 15.3M6 12H4V4H20V12H18.4L20.6 13.9C21.4 13.6 21.9 12.9 21.9 12V4C21.9 2.9 21 2 19.9 2H4C2.9 2 2 2.9 2 4V12C2 13.1 2.9 14 4 14H6V12Z\" /></svg>\n",
  'call_to_action_section': "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M2 7.5h7v9H2zM12 8h8m-8 5h4m-4 3h6\" stroke-width=\"1.5\"/></svg>\n",
  'carousel': "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><title>view-carousel-outline</title><path d=\"M2 6H6V17H2V6M7 19H17V4H7V19M9 6H15V17H9V6M18 6H22V17H18V6Z\" /></svg>\n",
  'chart': "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><title>eye</title><path d=\"M12,9A3,3 0 0,0 9,12A3,3 0 0,0 12,15A3,3 0 0,0 15,12A3,3 0 0,0 12,9M12,17A5,5 0 0,1 7,12A5,5 0 0,1 12,7A5,5 0 0,1 17,12A5,5 0 0,1 12,17M12,4.5C7,4.5 2.73,7.61 1,12C2.73,16.39 7,19.5 12,19.5C17,19.5 21.27,16.39 23,12C21.27,7.61 17,4.5 12,4.5Z\" /></svg>\n",
  'contact_box': "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><title>account-box-outline</title><path d=\"M19,19H5V5H19M19,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3M16.5,16.25C16.5,14.75 13.5,14 12,14C10.5,14 7.5,14.75 7.5,16.25V17H16.5M12,12.25A2.25,2.25 0 0,0 14.25,10A2.25,2.25 0 0,0 12,7.75A2.25,2.25 0 0,0 9.75,10A2.25,2.25 0 0,0 12,12.25Z\" /></svg>\r\n",
  'divider': "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><title>minus</title><path d=\"M19,13H5V11H19V13Z\" /></svg>\n",
  'icon_text_item': "<?xml version=\"1.0\" encoding=\"UTF-8\"?><svg id=\"uuid-633763d1-014d-4e50-8806-a560206ea69a\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><rect x=\"1.44\" y=\"7.04\" width=\"4.22\" height=\"4.22\" rx=\".25\" ry=\".25\" style=\"stroke-width:0px;\"/><rect x=\"6.62\" y=\"7.04\" width=\"15.94\" height=\"1.67\" rx=\".2\" ry=\".2\" style=\"stroke-width:0px;\"/><rect x=\"6.62\" y=\"9.79\" width=\"15.94\" height=\"1.67\" rx=\".2\" ry=\".2\" style=\"stroke-width:0px;\"/><rect x=\"6.62\" y=\"12.54\" width=\"15.94\" height=\"1.67\" rx=\".2\" ry=\".2\" style=\"stroke-width:0px;\"/><rect x=\"6.62\" y=\"15.29\" width=\"10.99\" height=\"1.67\" rx=\".2\" ry=\".2\" style=\"stroke-width:0px;\"/></svg>",
  'icon_text_list': "<?xml version=\"1.0\" encoding=\"UTF-8\"?><svg id=\"uuid-42ea6f3c-630f-4682-8d5c-ff8bd9d1a6d4\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><rect x=\"2.58\" y=\"1.68\" width=\"3.43\" height=\"3.43\" rx=\".25\" ry=\".25\" style=\"stroke-width:0px;\"/><rect x=\"6.82\" y=\"1.68\" width=\"14.6\" height=\".9\" rx=\".2\" ry=\".2\" style=\"stroke-width:0px;\"/><rect x=\"6.82\" y=\"3.17\" width=\"14.6\" height=\".9\" rx=\".2\" ry=\".2\" style=\"stroke-width:0px;\"/><rect x=\"6.82\" y=\"4.66\" width=\"14.6\" height=\".9\" rx=\".2\" ry=\".2\" style=\"stroke-width:0px;\"/><rect x=\"6.82\" y=\"6.15\" width=\"10.07\" height=\".9\" rx=\".2\" ry=\".2\" style=\"stroke-width:0px;\"/><rect x=\"2.58\" y=\"9.32\" width=\"3.43\" height=\"3.43\" rx=\".25\" ry=\".25\" style=\"stroke-width:0px;\"/><rect x=\"6.82\" y=\"9.32\" width=\"14.6\" height=\".9\" rx=\".2\" ry=\".2\" style=\"stroke-width:0px;\"/><rect x=\"6.82\" y=\"10.8\" width=\"14.6\" height=\".9\" rx=\".2\" ry=\".2\" style=\"stroke-width:0px;\"/><rect x=\"6.82\" y=\"12.29\" width=\"14.6\" height=\".9\" rx=\".2\" ry=\".2\" style=\"stroke-width:0px;\"/><rect x=\"6.82\" y=\"13.78\" width=\"10.07\" height=\".9\" rx=\".2\" ry=\".2\" style=\"stroke-width:0px;\"/><rect x=\"2.58\" y=\"16.95\" width=\"3.43\" height=\"3.43\" rx=\".25\" ry=\".25\" style=\"stroke-width:0px;\"/><rect x=\"6.82\" y=\"16.95\" width=\"14.6\" height=\".9\" rx=\".2\" ry=\".2\" style=\"stroke-width:0px;\"/><rect x=\"6.82\" y=\"18.44\" width=\"14.6\" height=\".9\" rx=\".2\" ry=\".2\" style=\"stroke-width:0px;\"/><rect x=\"6.82\" y=\"19.93\" width=\"14.6\" height=\".9\" rx=\".2\" ry=\".2\" style=\"stroke-width:0px;\"/><rect x=\"6.82\" y=\"21.42\" width=\"10.07\" height=\".9\" rx=\".2\" ry=\".2\" style=\"stroke-width:0px;\"/></svg>",
  'iframe': "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><title>application</title><path d=\"M21 2H3C1.9 2 1 2.9 1 4V20C1 21.1 1.9 22 3 22H21C22.1 22 23 21.1 23 20V4C23 2.9 22.1 2 21 2M21 7H3V4H21V7Z\" /></svg>\r\n",
  'image': "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><title>image</title><path d=\"M8.5,13.5L11,16.5L14.5,12L19,18H5M21,19V5C21,3.89 20.1,3 19,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19Z\" /></svg>\n",
  'infobox': "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\">\n    <path fill=\"currentColor\" d=\"M3 21h8v-8H3m2 2h4v4H5m-2-8h8V3H3m2 2h4v4H5m8-6v8h8V3m-2 6h-4V5h4m-1 11h3v2h-3v3h-2v-3h-3v-2h3v-3h2Z\"/>\n</svg>\n",
  'media_list': "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><path d=\"M9,1V7H5L12,14L19,7H15V1H9M5,16V18H19V16H5M5,20V22H19V20H5Z\" /></svg>",
  'milestones': "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"96\" height=\"96\" viewBox=\"0 0 24 24\">\n    <path fill=\"#8f8f8f\" d=\"M7 2h2v20H7zm12 7l-8 5.6V3.4z\" />\n</svg>\n",
  'quote': "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><title>format-quote-close</title><path d=\"M14,17H17L19,13V7H13V13H16M6,17H9L11,13V7H5V13H8L6,17Z\" /></svg>\n",
  'table': "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><title>table</title><path d=\"M5,4H19A2,2 0 0,1 21,6V18A2,2 0 0,1 19,20H5A2,2 0 0,1 3,18V6A2,2 0 0,1 5,4M5,8V12H11V8H5M13,8V12H19V8H13M5,14V18H11V14H5M13,14V18H19V14H13Z\" /></svg>\n",
  'teaser': "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><title>text-box</title><path d=\"M14,17H7V15H14M17,13H7V11H17M17,9H7V7H17M19,3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3Z\" /></svg>\n",
  'teaser_list': "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><title>view-grid</title><path d=\"M3,11H11V3H3M3,21H11V13H3M13,21H21V13H13M13,3V11H21V3\" /></svg>\n",
  'teaser_with_external_link': "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><title>text-box</title><path d=\"M14,17H7V15H14M17,13H7V11H17M17,9H7V7H17M19,3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3Z\" /></svg>\n",
  'text': "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><title>text-long</title><path d=\"M4,5H20V7H4V5M4,9H20V11H4V9M4,13H20V15H4V13M4,17H14V19H4V17Z\" /></svg>\n",
  'text_image': "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><title>image-text</title><path d=\"M22 13H14V11H22V13M22 7H14V9H22V7M14 17H22V15H14V17M12 9V15C12 16.1 11.1 17 10 17H4C2.9 17 2 16.1 2 15V9C2 7.9 2.9 7 4 7H10C11.1 7 12 7.9 12 9M10.5 15L8.3 12L6.5 14.3L5.3 12.8L3.5 15H10.5Z\" /></svg>\n",
  'video': "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><title>youtube</title><path d=\"M10,15L15.19,12L10,9V15M21.56,7.17C21.69,7.64 21.78,8.27 21.84,9.07C21.91,9.87 21.94,10.56 21.94,11.16L22,12C22,14.19 21.84,15.8 21.56,16.83C21.31,17.73 20.73,18.31 19.83,18.56C19.36,18.69 18.5,18.78 17.18,18.84C15.88,18.91 14.69,18.94 13.59,18.94L12,19C7.81,19 5.2,18.84 4.17,18.56C3.27,18.31 2.69,17.73 2.44,16.83C2.31,16.36 2.22,15.73 2.16,14.93C2.09,14.13 2.06,13.44 2.06,12.84L2,12C2,9.81 2.16,8.2 2.44,7.17C2.69,6.27 3.27,5.69 4.17,5.44C4.64,5.31 5.5,5.22 6.82,5.16C8.12,5.09 9.31,5.06 10.41,5.06L12,5C16.19,5 18.8,5.16 19.83,5.44C20.73,5.69 21.31,6.27 21.56,7.17Z\" /></svg>\n",
  'view': "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><title>eye</title><path d=\"M12,9A3,3 0 0,0 9,12A3,3 0 0,0 12,15A3,3 0 0,0 15,12A3,3 0 0,0 12,9M12,17A5,5 0 0,1 7,12A5,5 0 0,1 12,7A5,5 0 0,1 17,12A5,5 0 0,1 12,17M12,4.5C7,4.5 2.73,7.61 1,12C2.73,16.39 7,19.5 12,19.5C17,19.5 21.27,16.39 23,12C21.27,7.61 17,4.5 12,4.5Z\" /></svg>\n",
  'webform': "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\">\r\n    <title>form-select</title>\r\n    <path d=\"M15 5H18L16.5 7L15 5M5 2H19C20.11 2 21 2.9 21 4V20C21 21.11 20.11 22 19 22H5C3.9 22 3 21.11 3 20V4C3 2.9 3.9 2 5 2M5 4V8H19V4H5M5 20H19V10H5V20M7 12H17V14H7V12M7 16H17V18H7V16Z\"/>\r\n</svg>\r\n"
}



const globalOptions = {"bkVisibleLanguages":{"type":"checkboxes","label":"Visible languages","options":{},"default":[]},"bkHiddenGlobally":{"type":"checkbox","label":"Hide globally","default":false},"teaserStyle":{"type":"radios","label":"Darstellung","default":"grid","options":{"grid":"Grid","staggered_grid":"Versetztes Grid"}},"mobileStyle":{"type":"radios","label":"Mobile Darstellung","default":"stapel","options":{"stapel":"Stapel","slider":"Slider"}},"spacing":{"type":"radios","label":"Spacing","default":"none","displayAs":"icons","options":{"none":{"label":"no spacing","icon":"icon-blokkli-option-no-spacing"},"small":{"label":"small spacing","icon":"icon-blokkli-option-small-spacing"},"large":{"label":"large spacing","icon":"icon-blokkli-option-large-spacing"}}}}

const renderKey = "buPo9Aqs9rwYy8ASa_6hseUh8iZrJku7qglAWJDum2k"

const definitions = {
  blocks,
  fragments,
  icons,
  globalOptions,
  renderKey
}

export default definitions